export type IFormBindings = IDCA.IGenericFunc;

export function _formBindings(): void {
  $('#content')
    .off('click', '.aria-expander')
    .on('click', '.aria-expander', (e) => {
      window.DexeroCoreApp._toggleAriaExpander($(e.currentTarget));
    })
    .off('click', '.reset-file-upload')
    .on('click', '.reset-file-upload', (e) => {
      const $button = $(e.currentTarget);
      const json = JSON.parse(decodeURIComponent($button.data('json')));
      const fileName = $button.data('file-name');
      const { modalTitle, modalBody } = json;
      const promise = window.DexeroCoreApp.confirmUserAction(
        'warning',
        `${modalTitle} ${fileName}?`,
        modalBody
      );

      promise.done(() => {
        window.DexeroCoreApp._resetFileUpload($button, json);
      });
    })
    .off('click', '.file-upload-input:not(.ignore)')
    .on('click', '.file-upload-input:not(.ignore)', (e) => {
      const $input = $(e.currentTarget) as JQuery<HTMLInputElement>;
      const fieldIdent = $input.attr('id');
      const uuid = $input.closest('form').find('input[name="uuid"]').val();
      const $fileNameSpan = $(`#file-name-${fieldIdent}`) as IjQueryElm;
      const fileName = $fileNameSpan.data('file-name');
      const overwriteFile = $fileNameSpan.hasClass('overwrite-file');

      if (fileName && uuid && !overwriteFile) {
        e.preventDefault();
        window.DexeroCoreApp._warnFileOverwrite($input, $fileNameSpan, fileName);
      }
    })
    .off('change', '.file-upload-input:not(.ignore)')
    .on('change', '.file-upload-input:not(.ignore)', (e) => {
      // If user tries to upload something new, but already has had a file uploaded which has removed the validation for this field
      // We need to re-enable validation
      const $currentTarget = $(e.currentTarget);
      if ($currentTarget.val() && $currentTarget.hasClass('ignore-for-validation')) {
        $currentTarget.removeClass('ignore-for-validation');
      }
      $currentTarget.valid();
    })
    .off('change', 'input.auto-image-uploader')
    .on('change', 'input.auto-image-uploader', (e) => {
      const $currentTarget = $(e.currentTarget);
      if (!$currentTarget.valid() || !$currentTarget.val()) {
        return;
      }
      window.DexeroCoreApp._autoUploadImages($currentTarget as JQuery<HTMLInputElement>);
    })
    .off('click', '.get-child-data')
    .on('click', '.get-child-data', (e) => {
      window.DexeroCoreApp._loadDataEntryChild(e.currentTarget);
      e.preventDefault();
      return false;
    })
    .off('click', '.add-button.ajax-action, .edit-button.ajax-action')
    .on('click', '.add-button.ajax-action, .edit-button.ajax-action', (e) => {
      const $currentTarget = $(e.currentTarget);
      if ($currentTarget.hasClass('disabled')) {
        return;
      }
      window.DexeroCoreApp.publish('/sessionUser/restart/');
      window.DexeroCoreApp._loadChildFormViaAjax($currentTarget);
    })
    .off('click', '.close-subform')
    .on('click', '.close-subform', (e) => {
      window.DexeroCoreApp.publish('/sessionUser/restart/');
      window.DexeroCoreApp._closeChildFormViaAjax($(e.currentTarget));
    })
    .off('click', '.delete-button.ajax-action')
    .on('click', '.delete-button.ajax-action', (e) => {
      window.DexeroCoreApp.publish('/sessionUser/restart/');
      window.DexeroCoreApp._removeEntryViaAjax($(e.currentTarget));
    })
    .off('click', '.reset-form-button')
    .on('click', '.reset-form-button', (e) => {
      const $form = $(e.currentTarget).closest('form') as JQuery<HTMLFormElement>;
      window.DexeroCoreApp.resetForm($form);
    })
    .off('change', ':input.automatic-date-setter')
    .on('change', ':input.automatic-date-setter', (e) => {
      ($ as any).log(`change Event triggered on automatic-date-setter = ${e}`);
      // Only process if change is triggered by user
      if (e.originalEvent === undefined && (e as any).isTrigger === undefined) {
        ($ as any).log(`change NOT triggered by user: EXIT`);
        return;
      }
      window.DexeroCoreApp._processLinkedAutoDates($(e.currentTarget) as JQuery<HTMLInputElement>);
    })
    .off('click', '.quick-save-form-button')
    .on('click', '.quick-save-form-button', (e) => {
      window.DexeroCoreApp.handleQuickSaveButtonClick(e);
    });
}
